<template>
  <div class="game-tr-select-game-with-text" :style="setGameStyle()">
    <div v-if="objectImageExist(imageData)" class="main-image-container" :style="getImageStyle(imageData)"></div>
    <tr-box
      v-if="words.length"
      :items="words"
      :config="boxConfig"
      :font-size="boxConfigFontSize"
      :style="getBoxStyle(startGameConfig.boxConfig)"
      class="box-style"
    ></tr-box>
    <div class="text-container" :style="getTextStyle()">
      <component :is="dynComponent" v-bind="$props"></component>
    </div>
  </div>
</template>
<script>
import _ from 'lodash';
import Vue from 'vue';
import * as utils from '../../Utils/inputUtils';
import TrSelect from '../TrSelect/TrSelect';
import defaultMixin from '../../mixins/defaultMixin';
import TrBox from '../../GameBaseElements/TrBox/TrBox';
export default {
  name: 'tr-select-game-with-text',
  components: { TrSelect, TrBox },
  props: {
    startGameConfig: {
      type: Object,
      default: function () {
        return {};
      },
    },
  },
  mixins: [defaultMixin],
  data() {
    return {
      imageData: {},
      text: this.startGameConfig.item.text,
      selected: [],
      baseItems: {},
      words: [],
      boxConfig: {
        x: (this.startGameConfig.boxConfig && this.startGameConfig.boxConfig.left) || 1,
        y: (this.startGameConfig.boxConfig && this.startGameConfig.boxConfig.top) || 14,
        width: (this.startGameConfig.boxConfig && this.startGameConfig.boxConfig.width) || 98,
        height: (this.startGameConfig.boxConfig && this.startGameConfig.boxConfig.height) || 12,
        unit: '%',
        wordConfig: (this.startGameConfig.boxConfig && this.startGameConfig.boxConfig.wordConfig) || {},
      },
    };
  },
  created() {},
  beforeMount() {
    this.init();
    this.text = this.parseText(this.text);
    /**
     * box text aplly
     */
    if (this.startGameConfig.words) {
      let syncData = this.startGameConfig.boxConfig.syncData;
      this.words = this.startGameConfig.words;
      if (this.startGameConfig.boxConfig && syncData) {
        this.words = _.intersection(
          this.startGameConfig.words,
          _.flattenDeep(
            _.map(this.textItem, (item) => {
              if (item[syncData]) {
                return [...item[syncData]];
              } else if (item.markers) {
                return _.flattenDeep(
                  _.map(item.markers, (item) => {
                    return [...item[syncData]];
                  })
                );
              }
              return [...item[syncData]];
            })
          )
        );
      }
      this.words = _.shuffle(this.words);
    }
  },
  methods: {
    /**
     * parsing function. Replace markes (__elem0__,__elem1__, etc.) to component and passing all data
     * @method parseText
     * @param  {String}  text base text with markers
     * @return {String}       reparsed text with correct components
     */
    parseText(text) {
      // let regExp = /__\w*__/g;
      text = _.split(text, /__\w*__/g);
      // text = regExp.exec(text);
      let parseText = [];
      parseText.push('<span>');
      _.each(text, (item, index) => {
        if (index <= text.length - 2) {
          let newText = `<tr-select
            :config="baseItems[${index}]"
            :style="getCustomStyle(baseItems[${index}])"
            :inputWidth="inputWidth(baseItems[${index}])"
            :inputHeight="inputHeight(baseItems[${index}])"
            :options="baseItems[${index}].options"
            :tr-select-value="selected[${index}]"
            @change="setNewValue($event,${index})"
            @click.native="resetCheckStatus"
            class="select-style"
          ></tr-select>`;
          parseText.push('<span>');
          parseText.push(item);
          parseText.push('</span>');
          parseText.push(newText);
        } else {
          parseText.push('<span>');
          parseText.push(item);
          parseText.push('</span>');
        }
      });
      parseText.push('</span>');
      return parseText.join('');
    },
    /**
     * test if object objectExist
     * @method objectExist
     * @param  {*}    item testiing element
     * @return {Boolean}         true if is object
     */
    objectImageExist(item) {
      return _.isObject(item) && !_.isNil(item.imagePath);
    },
    getImageStyle(imageData) {
      if (_.isObject(imageData) && imageData.imagePath) {
        if (!imageData.pos) {
          imageData = Object.assign({}, imageData, {
            pos: {
              x: 0,
              y: 0,
            },
          });
        }
        if (!imageData.height) {
          imageData = Object.assign({}, imageData, {
            height: 358,
          });
        }
        if (!imageData.width) {
          imageData = Object.assign({}, imageData, {
            width: 1850,
          });
        }
      }
      return _.merge(
        {
          position: 'relative',
          'background-size': 'contain',
          'background-repeat': 'no-repeat',
          'background-position': 'center,center',
        },
        this.getCustomStyle(imageData),
        {
          'background-image': `url(${require(`__staticDir/${this.$store.getters.multibookType}/${imageData.imagePath}`)})`,
          top: utils.elementTopPosition(imageData.pos.y, imageData.offsetVertical),
          left: utils.elementLeftPosition(imageData.pos.x, imageData.offsetHorizontal),
          width: utils.elementWidth(imageData.width),
          height: utils.elementHeight(imageData.height),
        }
      );
    },
    getTextStyle() {
      let pos = this.startGameConfig.item.pos || {};
      return _.merge({ position: 'relative' }, this.getCustomStyle(this.startGameConfig.item), {
        top: utils.elementTopPosition(pos.y, this.startGameConfig.item.offsetVertical),
        left: utils.elementLeftPosition(pos.x, this.startGameConfig.item.offsetHorizontal),
        width: utils.elementWidth(this.startGameConfig.item.width),
        height: utils.elementHeight(this.startGameConfig.item.height),
      });
    },
    getBoxStyle(box) {
      box.x = box.x;
      box.y = box.y;
      box.width = box.width;
      box.height = box.height;
      return _.merge({ position: 'absolute' }, this.getCustomStyle(box), {
        left: utils.elementLeftPosition(box.x, 0, '%'),
        top: utils.elementTopPosition(box.y, 0, '%'),
        width: utils.elementWidth(box.width, '%'),
        height: utils.elementHeight(box.height, '%'),
      });
    },
    setGameStyle() {
      return _.merge({ position: 'absolute' }, this.getCustomStyle(this.startGameConfig), {
        'flex-direction': this.startGameConfig.flexDirection || 'row',
        padding: this.startGameConfig.padding + '%',
        'margin-top': this.startGameConfig.marginTop + '%',
      });
    },
    getCustomStyle(item) {
      let customStyle = {};
      if (item.cssStyle) {
        if (_.isObject(item.cssStyle)) {
          customStyle = _.mapKeys(item.cssStyle, function (value, key) {
            return _.toString(key);
          });
        }
      }
      return customStyle;
    },
    init() {
      this.baseItems = this.prepareData();
      if (this.startGameConfig.mainImage) {
        this.imageData = this.startGameConfig.mainImage;
      }
      this.selected = _.map(this.baseItems, (item) => {
        return {
          correct: item.correct,
          val: '',
          block: false,
          inputStatus: null,
        };
      });
    },
    prepareData() {
      let data = _.cloneDeep(this.startGameConfig.items);
      data = _.map(_.cloneDeep(data), (elem) => {
        if (_.isArray(elem.options) && elem.shuffle) {
          elem.options = _.shuffle(elem.options);
        }
        return elem;
      });
      return data;
    },

    /**
     * reset all containerEnd without reset reactivity
     * @method resetGameAction
     */
    resetGameAction() {
      this.init();
      // _.each(this.inputData, (item, key, collection) => {
      //   item.val = "";
      //   item.text = "";
      //   item.block = false;
      //   item.inputStatus = null;
      // });
    },
    checkGameAction() {
      let status = _.reduce(
        this.selected,
        (result, value, key) => {
          let temVal = null;
          if (value.correct) {
            temVal = result && true;
            value.block = true;
            value.inputStatus = 'correct';
          } else {
            temVal = false;
            value.block = true;
            value.inputStatus = 'incorrect';
            setTimeout(() => {
              value.val = '';
              value.block = false;
              value.inputStatus = null;
            }, 1000);
          }
          return temVal;
        },
        true
      );
      console.log('ANSWER: ', status);
      if (!status) {
        _.each(this.selected, (item, key) => {
          console.log('item', item);
        });
      }
      return status;
    },
  },
  computed: {
    dynComponent() {
      const template = this.content ? this.content : this.text;
      let data = {
        imageData: {},
        text: _.cloneDeep(this.startGameConfig.item.text),
        selected: this.selected,
        baseItems: _.cloneDeep(this.baseItems),
        // items: _.cloneDeep(this.startGameConfig.items)
      };
      return {
        template,
        mixins: [defaultMixin],
        components: { TrSelect },
        data() {
          return data;
        },
        methods: {
          selectConfig(item) {
            return _.omit(item, ['pos', 'width', 'height']);
          },
          inputWidth(item) {
            if (item.width) {
              return item.width;
            } else if (item.inputWidth) {
              return item.inputWidth;
            } else if (this.startGameConfig.inputWidth) {
              return this.startGameConfig.inputWidth;
            }
            return false;
          },
          inputHeight(item) {
            if (item.height) {
              return item.height;
            } else if (item.inputHeight) {
              return item.inputHeight;
            } else if (this.startGameConfig.inputHeight) {
              return this.startGameConfig.inputHeight;
            }
            return false;
          },
          setNewValue(value, index) {
            let trValue = _.defaults({}, value, {
              correct: undefined,
              val: '',
              block: false,
              inputStatus: null,
            });
            trValue.val = value.text;
            _.assign(this.selected[index], trValue, { val: value });
          },
          getCustomStyle(item) {
            let customStyle = {};
            if (item.cssStyle) {
              if (_.isObject(item.cssStyle)) {
                customStyle = _.mapKeys(item.cssStyle, function (value, key) {
                  return _.toString(key);
                });
              }
            }
            return customStyle;
          },
        },
        props: this.$props, // re-use current props definitions
        // props: this.$options.props // re-use current props definitions
      };
    },
    boxConfigFontSize() {
      let fontSize = this.startGameConfig.boxConfig && this.startGameConfig.boxConfig.fontSize;
      return fontSize + 'px';
    },
  },
};
</script>

<style lang="scss" scoped>
@import '~@/assets/sass/variable';
@import '~@/assets/sass/iconColor';
$elementWidth: 1478px;
$elementHeight: 153px;
$fontSize: 35px;
%item {
  transition: all 0.5s;
  text-align: center;
  font-size: $fontSize;
  font-family: $gameFontFamily;
  font-style: normal;
  font-variant: normal;
  font-weight: 500;
}
.game-tr-select-game-with-text {
  height: 100%;
  width: 93%;
  margin-left: 1%;
  display: flex;
  justify-content: flex-start;
  align-items: center;
  .text-container {
    text-align: justify;
  }
}

.marker-style {
  width: 100px;
  height: 40px;
  display: inline-block;
}
</style>
